module.exports = __webpack_public_path__ + "static/media/8.question.dd08d944.mp4";